<p-card>
  <div class="mb-3"><strong>Container Infestation Rate</strong></div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-select
          #containerSelect
          appLockInitialWidth
          fluid="true"
          [options]="distinctContainers"
          [(ngModel)]="containerItem.id"
          data-testid="insectContainer"
          optionLabel="name"
          optionValue="id"
          filter="true"
          filterPlaceholder="Search Container"
          class="required"
          appendTo="body"
          (onChange)="emitContainerItem(); onChangeContainer()"
          [disabled]="isDisabled || editingInstance"></p-select>
        <label for="on_label">Container</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <div class="flex">
        <label for="active" style="padding-right: 1rem"
          >Standard :
          <i class="fa fa-circle-question" style="cursor: pointer; margin-left: 0.5rem" pTooltip="{{ standardTooltipText }}" tooltipPosition="right">
          </i>
        </label>
        <p-toggleswitch
          [(ngModel)]="containerItem.standard"
          data-testid="active"
          (onChange)="onStandardToggle($event)"
          [disabled]="containerItem.id === null || isDisabled" />
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-inputnumber
          [(ngModel)]="containerItem.quantityPerContainer"
          class="width-6 required"
          inputId="quantity"
          [disabled]="containerItem.standard"
          [useGrouping]="false"
          data-testid="quantity"
          [style]="{ width: '100%' }"
          (onInput)="emitContainerItem()" />
        <label for="quantity">Quantity</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">{{ containerItem.quantityPerContainer }} per {{ selectedContainer?.containerTypeName || 'container' }}</div>
  </div>
</p-card>
